module.exports = __webpack_public_path__ + "img/45600.61fcf695.jpg";